import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import store from './store';

Vue.config.productionTip = false
Vue.prototype.$buyerAPI = 'api.gridmarkets.com:8003/api/render/1.0'
Vue.prototype.$assetAPI = 'api.gridmarkets.com:5443/api/0.5'


const basic_token = localStorage.getItem('basic_token') || null;
const linkedin_token = localStorage.getItem('linkedin_token') || null;
const ispassword = JSON.parse(localStorage.getItem("ispassword")) || false;

if (linkedin_token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${linkedin_token}`
  axios.defaults.headers.common["GridMarkets-APIKey"] = "6c1523b3-5c5a-433c-96f1-72fe04ec407a";
}

if (basic_token){
  axios.defaults.headers.common['Authorization'] = `Basic ${basic_token}`;
  if (ispassword){
    axios.defaults.headers.common["GridMarkets-APIKey"] = "6c1523b3-5c5a-433c-96f1-72fe04ec407a";
  }else{
    delete axios.defaults.headers.common["GridMarkets-APIKey"];
  }
}

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
